/* Ayudate · Mensajes de validación */

import React from "react";

export function ListaErrores({ error, vivo = false }) {
  const lista = Array.isArray(error) ? error : [error];
  return (
    <div className="error" role="alert" aria-live={vivo ? "polite" : undefined}>
      <b>
        {lista.length === 1
          ? "Falta un dato para poder enviar:"
          : `Faltan ${lista.length} datos para poder enviar:`}
      </b>
      <ul>{lista.map((t, i) => <li key={i}>{t}</li>)}</ul>
    </div>
  );
}

export function Ayuda({ texto, error, mostrar }) {
  const mal = mostrar && error;
  return (
    <p className={`ayuda ${mal ? "mal" : ""}`} role={mal ? "alert" : undefined}>
      {mal ? error : texto}
    </p>
  );
}

/* Se repite igual debajo de todo campo de correo del sitio: el correo es
   el único canal por el que avisamos confirmaciones, pagos y accesos, así
   que vale la pena recordarlo aparte del resto de la ayuda del campo. */
export function NotaCorreo() {
  return (
    <p className="ayuda nota-correo">
      Asegúrese de que su correo sea el correcto, ya que es nuestro <b>medio oficial de comunicación</b>.
    </p>
  );
}

/* Tarjeta de alerta para un archivo rechazado (formato inválido, muy
   pesado, etc.), pensada para ir PEGADA arriba del campo de subida al que
   corresponde, no perdida al fondo del formulario junto al resto de los
   errores de envío. */
export function AlertaArchivo({ mensaje }) {
  if (!mensaje) return null;
  return (
    <div className="error alerta-archivo" role="alert">
      {mensaje}
    </div>
  );
}

/* Indicador en vivo junto al campo "Usuario" de un registro (ver
   lib/disponibilidadUsuario.js): verde si está libre, rojo si ya lo tiene
   otra persona. Reutiliza los chips .chip.success/.chip.danger que ya
   existen en toda la app, sin CSS nuevo. */
export function DisponibilidadUsuario({ estado }) {
  if (estado === "disponible") {
    return <span className="chip success" role="status">Usuario disponible</span>;
  }
  if (estado === "ocupado") {
    return <span className="chip danger" role="status">Ese usuario ya existe</span>;
  }
  if (estado === "verificando") {
    return <span className="chip off" role="status">Verificando…</span>;
  }
  return null;
}
